<div class="cable-tray-container">
    <sysque-options-line 
      [sysqueOption]="options" 
      (switchClicked)="onSwitchClicked($event)">
    </sysque-options-line>
  <div class="image-container">
    <canvas id="cable-tray-canvas" class="canvas"> </canvas>
  </div>
</div>
